import noop from 'lodash/noop';
import {
	PRODUCT_DISCOVERY_PROJECT,
	type ProjectType,
} from '@atlassian/jira-common-constants/src/project-types';
import {
	isSupportedEotmProjectType,
	type SupportedEotmProjectType,
} from '@atlassian/jira-end-of-trial-common';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { END_OF_TRIAL_MESSAGE_AUDIENCES } from './constants';

export const getEndOfTrialMessageAudience = (
	preDunningDaysLeft: number,
	projectType: SupportedEotmProjectType,
) => {
	if (preDunningDaysLeft >= 0 && preDunningDaysLeft <= 13) {
		return END_OF_TRIAL_MESSAGE_AUDIENCES[projectType][preDunningDaysLeft];
	}

	return undefined;
};

const getEndOfTrialMessageExperimentConfig = (projectType: ProjectType) => {
	if (!isSupportedEotmProjectType(projectType)) {
		throw new Error(`Invalid EOTM projectType: ${projectType}`);
	}

	if (projectType === PRODUCT_DISCOVERY_PROJECT) {
		const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = UNSAFE_noExposureExp(
			'end_of_trial_ep_message_jpd',
		);
		return {
			config: endOfTrialMessageConfig,
			fireStatsigExperimentExposure,
			flagKey: 'end_of_trial_ep_message_jpd',
		};
	}

	const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = UNSAFE_noExposureExp(
		'end_of_trial_ep_message_jsm',
	);
	return {
		config: endOfTrialMessageConfig,
		fireStatsigExperimentExposure,
		flagKey: 'end_of_trial_ep_message_jsm',
	};
};

export const getEndOfTrialMessageExperiment = (projectType: ProjectType) => {
	if (!isSupportedEotmProjectType(projectType)) {
		return {
			isEnrolled: false,
			cohort: 'not-enrolled',
			fireStatsigExperimentExposure: noop,
		};
	}

	const { config, fireStatsigExperimentExposure, flagKey } =
		getEndOfTrialMessageExperimentConfig(projectType);
	const cohort = config.get('cohort', 'not-enrolled');

	return {
		isEnrolled: cohort !== 'not-enrolled',
		cohort,
		fireStatsigExperimentExposure,
		flagKey,
	};
};
